import axios from 'axios';

// `REACT_APP_SERVER_URL` solo para probar en local contra otro server; el build usa producción.
const BASE_URL = process.env.REACT_APP_SERVER_URL || 'https://kabandu.fly.dev';

export const axiosPrivate = axios.create({
    baseURL: BASE_URL
});

axiosPrivate.interceptors.request.use(async (config) => {
    config.headers!['Content-Type'] = 'application/json;charset=UTF-8';
    return config;
});
